/*
 * 1DS JSLL SKU, 3.2.17
 * Copyright (c) Microsoft and contributors. All rights reserved.
 * (Microsoft Internal Only)
 */
/**
* Ix.ts
* @author Hector Hernandez (hectorh)
* @copyright Microsoft 2020
* ID swaps.
*/
import { notImplementedWarn } from "./Utils";
var Ix = /** @class */ (function () {
    function Ix() {
        // NO OP
        this.testHook = {};
    }
    Ix.prototype.init = function (config) {
        // NO OP
        notImplementedWarn("Ix init");
    };
    Ix.prototype.set = function (ids) {
        // NO OP
        notImplementedWarn("Ix set");
    };
    return Ix;
}());
export { Ix };
//# sourceMappingURL=Ix.js.map